import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useMyContext } from '../../../context/MyContext';
import '../../../css/custom-scrollbar.css';
import FullPageLoader from '../../../component/fullPageLoader/fullPageLoader';
import { Base_Url, b2bAllShipmentList, b2bDeleteShipment, Url_For_View_Document, b2bLabel, b2bewaybill, b2bPriceEstimator, b2bWarehouseListAll } from '../../../config/config';
import { CgSearch } from "react-icons/cg";
import { FaList, FaHourglassHalf, FaClipboardList, FaTruck, FaDownload, FaShippingFast, FaTimesCircle, FaExclamationCircle } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import Pagination from '@mui/material/Pagination';
import { RxCross2 } from "react-icons/rx";
import { FaEye, FaCopy } from "react-icons/fa";
import { FcPrint } from "react-icons/fc";

import B2BViewRateForword from '../../../component/b2b/models/priceEstimatorModelB2b';
import B2BViewAllShipment from '../../../component/b2b/models/viewAllShipmentModel';
import axios from 'axios';

const B2bAllShipmentList = () => {
    const { selectedCft, isDarkMode, isToggleSidebar, setorderId } = useMyContext();

    const [allData, setAllData] = useState([]);
    const [loadingOrderId, setLoadingOrderId] = useState(null);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [isloading, isSetLoading] = useState(false);
    const [isMobileCardView, setIsMobileCardView] = useState(false);

    const [activeTab, setActiveTab] = useState('all orders');
    const [searchTerm, setSearchTerm] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const limit = 15;

    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedShipment, setSelectedShipment] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [showSizeDropdown, setShowSizeDropdown] = useState(null);

    const [loadingOrderIdCancleOrder, setLoadingOrderIdCancleOrder] = useState(null);
    const [loadingOrderIdShip, setLoadingOrderIdShip] = useState(null);

    // State for failed reason popup
    const [failedReasonPopup, setFailedReasonPopup] = useState({ open: false, reason: '', orderId: '' });

    // State for user hover card smart position
    const [hoverCardPos, setHoverCardPos] = useState({ id: null, above: false });

    const handleUserMouseEnter = (e, rowId) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        setHoverCardPos({ id: rowId, above: spaceBelow < 280 });
    };
    const handleUserMouseLeave = () => setHoverCardPos({ id: null, above: false });

    // Smart hover state for origin, destination, weight
    const [addrHover, setAddrHover] = useState({ id: null, type: null, above: false });
    const [weightHover, setWeightHover] = useState({ id: null, above: false });

    const handleAddrEnter = (e, rowId, type) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setAddrHover({ id: rowId, type, above: window.innerHeight - rect.bottom < 260 });
    };
    const handleAddrLeave = () => setAddrHover({ id: null, type: null, above: false });

    const handleWeightEnter = (e, rowId) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setWeightHover({ id: rowId, above: window.innerHeight - rect.bottom < 180 });
    };
    const handleWeightLeave = () => setWeightHover({ id: null, above: false });

    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const userRole = localStorage.getItem("role") || localStorage.getItem("user_role") || "";
    const isAdmin = userRole?.toLowerCase() === "admin";
    const navigateForTrack = useNavigate();

    // Mobile Detection
    useEffect(() => {
        const checkScreen = () => setIsMobileCardView(window.innerWidth < 768);
        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    useEffect(() => {
        fetchAllShipments();
        fetchWareHouseList();
    }, []);

    const fetchAllShipments = async () => {
        try {
            setIsPageLoading(true);
            const response = await fetch(`${Base_Url}${b2bAllShipmentList}?page=1&limit=100000`, {
                method: 'GET',
                headers: { token: token || '', cus_id: cusid || '', 'Content-Type': 'application/json' },
            });
            const result = await response.json();
            setAllData(result?.data || []);
        } catch (err) {
            toast.error("Failed to load shipments");
        } finally {
            setIsPageLoading(false);
        }
    };

    const fetchWareHouseList = async () => {
        try {
            const response = await fetch(Base_Url + b2bWarehouseListAll, {
                headers: { token, cus_id: cusid, 'Content-Type': 'application/json' }
            });
            const data = await response.json();
        } catch (error) {
            console.error(error);
        }
    };

    const copyToClipboard = (text, label) => { navigator.clipboard.writeText(text); toast.success(`${label} copied!`); };

    const getTabCount = (tabKey) => {
        return allData.filter(item => {
            if (tabKey === 'all orders') return true;
            if (tabKey === 'Add Shipment list' || tabKey === 'pending')
                return item.status?.toLowerCase().includes('pending') || item.status?.toLowerCase() === 'manifest pending';
            if (tabKey === 'new order')
                return item.status?.toLowerCase().includes('new') || item.status?.toLowerCase() === 'manifest pending';
            if (tabKey === 'process order')
                return ['left_origin', 'in_transit', 'reach_destination'].some(s => item.status?.toLowerCase().includes(s));
            if (tabKey === 'manifest list')
                return item.status?.toLowerCase() === 'manifested';
            if (tabKey === 'failed')
                return item.status?.toLowerCase().includes('failed');
            return false;
        }).length;
    };

    const filteredData = useMemo(() => {
        let data = [...allData];

        switch (activeTab) {
            case 'Add Shipment list':
            case 'pending':
                data = data.filter(item => item.status?.toLowerCase().includes('pending') || item.status?.toLowerCase() === 'manifest pending');
                break;
            case 'new order':
                data = data.filter(item => item.status?.toLowerCase().includes('new') || item.status?.toLowerCase() === 'manifest pending');
                break;
            case 'process order':
                data = data.filter(item => ['left_origin', 'in_transit', 'reach_destination'].some(s => item.status?.toLowerCase().includes(s)));
                break;
            case 'manifest list':
                data = data.filter(item => item.status?.toLowerCase() === 'manifested');
                break;
            case 'failed':
                data = data.filter(item => item.status?.toLowerCase().includes('failed'));
                break;
            default:
                break;
        }

        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            data = data.filter(row =>
                row.order_id?.toString().toLowerCase().includes(term) ||
                row.waybill?.toString().includes(term) ||
                row.lrn?.toString().includes(term)
            );
        }
        return data;
    }, [allData, activeTab, searchTerm]);

    const paginatedData = filteredData.slice((currentPage - 1) * limit, currentPage * limit);
    const totalPages = Math.ceil(filteredData.length / limit);

    useEffect(() => setCurrentPage(1), [activeTab, searchTerm]);

    const handleViewClick = (row) => {
        setSelectedShipment(row);
        setIsPopupOpen(true);
    };

    // CHANGE 4: Track disabled if pending or no AWB
    const handleClick = (row) => {
        const isPending = row.status?.toLowerCase().includes('pending') || row.status?.toLowerCase() === 'manifest pending';
        const hasWaybill = !!(row.waybill || row.lrn);

        if (isPending || !hasWaybill) {
            toast.warning("Tracking available only after shipment is processed and AWB is generated.");
            return;
        }

        setorderId(row.order_id);
        navigateForTrack("/b2b/shipment/track");
    };

    const handleCancelOrder = async (orderId) => {
        const confirmResult = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to cancel this order?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, cancel it!',
        });
        if (!confirmResult.isConfirmed) return;

        setIsPageLoading(true);
        try {
            const response = await fetch(`${Base_Url}${b2bDeleteShipment}/${orderId}`, {
                method: 'GET',
                headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
            });
            if (response.ok) {
                setAllData(prev => prev.filter(item => item.order_id !== orderId));
                toast.success("Order canceled successfully!");
            }
        } catch (error) {
            toast.error("Failed to cancel order");
        } finally {
            setIsPageLoading(false);
        }
    };

    const handlePrintLabel = async (orderId, size = "A4") => {
        setIsPageLoading(true);
        try {
            const response = await fetch(`${Base_Url}${b2bLabel}`, {
                method: 'POST',
                headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
                body: JSON.stringify({ order_id: orderId, size }),
            });
            const data = await response.json();
            if (data.label_link) {
                window.open(data.label_link, '_blank');
                toast.success("Label opened successfully!");
            } else {
                toast.error("No label found");
            }
        } catch (error) {
            toast.error('Failed to generate label');
        } finally {
            setIsPageLoading(false);
            setShowSizeDropdown(null);
        }
    };

    // CHANGE 3: Waybill download handler
    const handleDownloadWaybill = async (orderId) => {
        setIsPageLoading(true);
        try {
            const response = await fetch(`${Base_Url}${b2bewaybill}`, {
                method: 'POST',
                headers: {
                    token,
                    cus_id: cusid,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    order_id: orderId,
                    size: "A4"
                }),
            });

            const data = await response.json();

            if (data.order_id) {
                const labelUrl = data?.document_label?.label_link || data?.box_labels?.[0]?.label_link;

                if (labelUrl) {
                    window.open(labelUrl, '_blank');
                    toast.success("Shipment label opened successfully!");
                } else {
                    toast.error("No label link found in response.");
                }
                setIsPageLoading(false);
                setLoadingOrderId(null);
            } else {
                toast.error(data.message || "Failed to generate label");
                setLoadingOrderId(null);
                setIsPageLoading(false);
            }
        } catch (error) {
            toast.error('Failed to generate waybill');
        } finally {
            setIsPageLoading(false);
            setShowSizeDropdown(null);
        }
    };

    const hanldeShipNow = async (order) => {
        if (!order.status?.toLowerCase().includes('pending')) {
            toast.error("Only Pending orders can be shipped");
            return;
        }

        setLoadingOrderIdShip(order.order_id);
        setIsPageLoading(true);

        try {
            const pickupLocation = JSON.parse(order.pickup_location || '{}');
            const dropoffLocation = JSON.parse(order.dropoff_location || '{}');
            const invoices = JSON.parse(order.invoices || "[]");
            const invoiceAmount = invoices.length > 0 ? parseFloat(invoices[0].inv_amt) : 0;

            const payload = {
                retailer_id: parseInt(order.retailer_id),
                origin_pincode: pickupLocation.zip,
                destination_pincode: dropoffLocation.zip,
                weight: parseFloat(order.total_weight || 0),
                invoice_value: invoiceAmount,
                cft: selectedCft,
                dimensions: [{
                    total_length: order.total_length,
                    total_width: order.total_width,
                    total_height: order.total_height
                }]
            };

            const response = await axios.post(Base_Url + b2bPriceEstimator, payload, {
                headers: { token, cus_id: cusid, 'Content-Type': 'application/json' }
            });

            if (response.data.status === "success") {
                setSelectedShipment(order);
                setIsPopupOpen(true);
            } else {
                toast.error(response.data.message || "Something went wrong");
            }
        } catch (error) {
            toast.error("Ship Now Failed");
        } finally {
            setLoadingOrderIdShip(null);
            setIsPageLoading(false);
        }
    };

    // CHANGE 2: Show failed reason
    const handleShowFailedReason = (row) => {
        const reason = row.remarks || row.failed_reason || row.failure_reason || row.cancel_reason || row.remark || "No reason provided";
        setFailedReasonPopup({ open: true, reason, orderId: row.order_id });
    };

    const getStatusStyle = (status) => {
        if (!status) return 'bg-gray-100 text-gray-600';
        const s = status.toLowerCase();
        if (s.includes('failed')) return 'bg-red-100 text-red-700';
        if (s.includes('pending') || s.includes('manifest pending')) return 'bg-yellow-100 text-yellow-700';
        if (s.includes('delivered') || s.includes('completed')) return 'bg-emerald-100 text-emerald-700';
        return 'bg-blue-100 text-blue-700';
    };

    const tabs = [
        { key: "all orders", label: "All Orders", icon: <FaList /> },
        { key: "Add Shipment list", label: "Pending", icon: <FaTruck /> },
        { key: "new order", label: "New Order", icon: <MdOutlinePendingActions /> },
        { key: "process order", label: "In Process", icon: <FaClipboardList /> },
        { key: "manifest list", label: "Manifested", icon: <FaHourglassHalf /> },
        { key: "failed", label: "Failed", icon: <FaTimesCircle /> },
    ];

    const labelSizes = [
        { value: "A4", label: "A4" },
        { value: "3by2", label: "3×2" }
    ];

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'}`}>
            <NavBar />
            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && <Sidebar />}

                <FullPageLoader isLoading={isPageLoading} message="Processing..." />

                <div className="flex-1 p-3 md:p-6 overflow-y-auto custom-scrollbar min-w-0">
                    <h1 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800 dark:text-white">
                        All B2B Shipments
                    </h1>

                    {/* Tabs + Search */}
                    <div className="flex flex-col md:flex-row md:items-end gap-3 md:gap-4 mb-6">
                        {/* CHANGE 1: Tab scrollbar hidden using scrollbar-hide + inline style */}
                        <div
                            className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide flex-1"
                            style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}
                        >
                            {tabs.map(tab => {
                                const count = getTabCount(tab.key);
                                const isActive = activeTab === tab.key;
                                return (
                                    <button
                                        key={tab.key}
                                        onClick={() => setActiveTab(tab.key)}
                                        className={`flex items-center gap-1.5 px-3 md:px-5 py-2 md:py-3 text-xs md:text-sm font-medium rounded-2xl transition-all whitespace-nowrap flex-shrink-0
                                            ${isActive ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg" : "bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700"}`}
                                    >
                                        <span className="hidden sm:inline">{tab.icon}</span>
                                        <span>{tab.label}</span>
                                        <span className={`ml-1 px-1.5 py-0.5 text-[10px] rounded-full ${isActive ? 'bg-white/30' : 'bg-gray-200 dark:bg-gray-700'}`}>
                                            {count}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>

                        <div className="relative w-full md:w-80 lg:w-96">
                            <CgSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                            <input
                                type="text"
                                placeholder="Search by Order ID, Waybill..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-10 pr-4 py-2.5 md:py-3 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-2xl focus:border-blue-500 outline-none text-sm"
                            />
                        </div>
                    </div>

                    {/* Desktop Table */}
                    {!isMobileCardView && (
                        <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700">
                            <div className="overflow-x-auto">
                                <table className="w-full border-collapse min-w-[1200px] text-sm">
                                    <thead>
                                        <tr className="bg-slate-50 dark:bg-gray-800 border-b-2 border-indigo-200 dark:border-indigo-800">
                                            <th className="py-4 px-3 w-12"><input type="checkbox" className="w-4 h-4" /></th>
                                            <th className="py-4 px-3 text-left">Order ID</th>
                                            {isAdmin && <th className="py-4 px-3 text-left">User</th>}
                                            <th className="py-4 px-3 text-left">Origin</th>
                                            <th className="py-4 px-3 text-left">Destination</th>
                                            <th className="py-4 px-3 text-left">Description</th>
                                            <th className="py-4 px-3 text-center">Boxes</th>
                                            <th className="py-4 px-3 text-center">Weight</th>
                                            <th className="py-4 px-3 text-right">Amount</th>
                                            <th className="py-4 px-3 text-center">Status</th>
                                            <th className="py-4 px-3 text-center">Date</th>
                                            <th className="py-4 px-3 text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                                        {paginatedData.map((row, index) => {
                                            const pickup = row.pickup_location ? JSON.parse(row.pickup_location || '{}') : {};
                                            const dropoff = row.dropoff_location ? JSON.parse(row.dropoff_location || '{}') : {};

                                            const statusLower = row.status?.toLowerCase() || "";
                                            const isManifestPending = statusLower === "manifest pending";
                                            const isPending = statusLower.includes("pending") && !isManifestPending;
                                            const isFailed = statusLower.includes("failed");
                                            const hasWaybill = !!(row.waybill || row.lrn);

                                            // Track disabled if pending/manifest pending or no AWB
                                            const isTrackDisabled = (isPending || isManifestPending) || !hasWaybill;

                                            return (
                                                <tr key={row.id}
                                                    className={`hover:bg-gray-50 dark:hover:bg-gray-800/50 row-animate transition-all
                                                        ${isFailed ? 'bg-red-50/70 dark:bg-red-950/30' : ''}`}
                                                    style={{ animationDelay: `${index * 40}ms` }}
                                                >
                                                    <td className="py-4 px-3 text-center"><input type="checkbox" className="w-4 h-4" /></td>

                                                    <td className="py-4 px-3">
                                                        <div className="flex flex-col">
                                                            <div className="flex items-center gap-2">
                                                                {/* CHANGE 4: Disabled style + tooltip when track not available */}
                                                                <span
                                                                    onClick={() => handleClick(row)}
                                                                    title={isTrackDisabled ? 'Tracking unavailable: pending or no AWB' : 'Track shipment'}
                                                                    className={`font-bold text-sm transition-colors select-none
                                                                        ${isTrackDisabled
                                                                            ? 'text-gray-400 cursor-not-allowed opacity-60'
                                                                            : 'text-indigo-600 hover:text-indigo-800 cursor-pointer'
                                                                        }`}
                                                                >
                                                                    #{row.order_id}
                                                                </span>
                                                                <FaCopy
                                                                    className="cursor-pointer text-gray-400 hover:text-gray-600"
                                                                    size={13}
                                                                    onClick={() => copyToClipboard(row.order_id, "Order ID")}
                                                                />
                                                            </div>
                                                            {hasWaybill && (
                                                                <div className="text-[10px] text-gray-400 mt-0.5">AWB: {row.waybill || row.lrn}</div>
                                                            )}
                                                        </div>
                                                    </td>

                                                    {/* Admin: User info td with professional hover card */}
                                                    {/* Admin: User info td with professional hover card */}
                                                    {isAdmin && (
                                                        <td className="py-4 px-3 text-xs">
                                                            <div
                                                                className="relative inline-block w-full"
                                                                onMouseEnter={(e) => handleUserMouseEnter(e, row.id)}
                                                                onMouseLeave={handleUserMouseLeave}
                                                            >
                                                                {(() => {
                                                                    // ❌ Billing details use nahi karni
                                                                    // ✅ Sirf Origin (pickup) details show karni hain
                                                                    const displayName =
                                                                        pickup?.consignee_name ||
                                                                        row.user_name ||
                                                                        row.retailer_name ||
                                                                        '—';

                                                                    const profileImg =
                                                                        row.profile_image ||
                                                                        row.user_profile ||
                                                                        row.avatar ||
                                                                        null;

                                                                    return (
                                                                        <div className="flex items-center gap-2 cursor-default">
                                                                            {/* Avatar */}
                                                                            <div className="w-8 h-8 rounded-full flex-shrink-0 overflow-hidden bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center">
                                                                                {profileImg ? (
                                                                                    <img
                                                                                        src={profileImg}
                                                                                        alt={displayName}
                                                                                        className="w-full h-full object-cover"
                                                                                        onError={(e) => {
                                                                                            e.target.style.display = 'none';
                                                                                            e.target.nextSibling.style.display = 'flex';
                                                                                        }}
                                                                                    />
                                                                                ) : null}

                                                                                <span
                                                                                    className={`text-white font-bold text-[12px] ${profileImg ? 'hidden' : 'flex'
                                                                                        } items-center justify-center w-full h-full`}
                                                                                >
                                                                                    {displayName.charAt(0).toUpperCase()}
                                                                                </span>
                                                                            </div>

                                                                            <div className="min-w-0">
                                                                                <div className="font-semibold text-gray-700 dark:text-gray-200 truncate max-w-[110px] capitalize">
                                                                                    {displayName}
                                                                                </div>
                                                                                <div className="text-[10px] text-indigo-500 font-medium">
                                                                                    #{row.user_id || '—'}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })()}

                                                                {/* Hover Card - Origin Details */}
                                                                {hoverCardPos.id === row.id &&
                                                                    (() => {
                                                                        const hName =
                                                                            pickup?.consignee_name ||
                                                                            row.user_name ||
                                                                            row.retailer_name ||
                                                                            '—';

                                                                        const hPhone = pickup?.phone || '';
                                                                        const hCity = pickup?.city || '';
                                                                        const hState = pickup?.state || '';
                                                                        const hPin = pickup?.zip || '';
                                                                        const hAddr = [hCity, hState, hPin]
                                                                            .filter(Boolean)
                                                                            .join(', ');

                                                                        return (
                                                                            <div
                                                                                className={`absolute left-0 z-[999] w-48 pointer-events-none ${hoverCardPos.above
                                                                                    ? 'bottom-full mb-1'
                                                                                    : 'top-full mt-1'
                                                                                    }`}
                                                                            >
                                                                                {!hoverCardPos.above && (
                                                                                    <div className="ml-4 w-2.5 h-2.5 bg-indigo-500 rotate-45 -mb-1.5 relative z-10" />
                                                                                )}

                                                                                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-600 overflow-hidden">
                                                                                    {/* Header */}
                                                                                    <div className="bg-gradient-to-r from-indigo-500 to-purple-600 px-3 py-2 flex items-center gap-2">
                                                                                        <div className="w-7 h-7 rounded-full overflow-hidden bg-white/20 flex items-center justify-center flex-shrink-0">
                                                                                            {(row.profile_image ||
                                                                                                row.user_profile ||
                                                                                                row.avatar) ? (
                                                                                                <img
                                                                                                    src={
                                                                                                        row.profile_image ||
                                                                                                        row.user_profile ||
                                                                                                        row.avatar
                                                                                                    }
                                                                                                    alt=""
                                                                                                    className="w-full h-full object-cover"
                                                                                                />
                                                                                            ) : (
                                                                                                <span className="text-white font-bold text-xs">
                                                                                                    {hName.charAt(0).toUpperCase()}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>

                                                                                        <div className="min-w-0">
                                                                                            <div className="text-white font-semibold text-[11px] leading-tight truncate capitalize">
                                                                                                {hName}
                                                                                            </div>
                                                                                            <div className="text-indigo-200 text-[10px]">
                                                                                                #{row.user_id || '—'}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Body */}
                                                                                    <div className="divide-y divide-gray-100 dark:divide-gray-700">
                                                                                        {/* Phone */}
                                                                                        {hPhone && (
                                                                                            <div className="flex items-center gap-2 px-3 py-1.5">
                                                                                                <span className="text-[11px]">📞</span>
                                                                                                <div>
                                                                                                    <div className="text-[9px] text-gray-400 uppercase tracking-wide">
                                                                                                        Phone
                                                                                                    </div>
                                                                                                    <div className="text-[10px] font-semibold text-gray-800 dark:text-white">
                                                                                                        {hPhone}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}

                                                                                        {/* Origin Address */}
                                                                                        {hAddr && (
                                                                                            <div className="flex items-center gap-2 px-3 py-1.5">
                                                                                                <span className="text-[11px]">📍</span>
                                                                                                <div>
                                                                                                    <div className="text-[9px] text-gray-400 uppercase tracking-wide">
                                                                                                        Origin
                                                                                                    </div>
                                                                                                    <div className="text-[10px] font-semibold text-gray-800 dark:text-white">
                                                                                                        {hAddr}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                                {hoverCardPos.above && (
                                                                                    <div className="ml-4 w-2.5 h-2.5 bg-white dark:bg-gray-800 border-r border-b border-gray-200 dark:border-gray-600 rotate-45 -mt-1.5 relative z-10" />
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                            </div>
                                                        </td>
                                                    )}

                                                    <td className="py-4 px-3 text-xs">
                                                        <div className="font-medium text-gray-700 dark:text-gray-200">{pickup.city || '—'}</div>
                                                        <div className="relative"
                                                            onMouseEnter={(e) => handleAddrEnter(e, row.id, 'pickup')}
                                                            onMouseLeave={handleAddrLeave}>
                                                            <div className="text-gray-400 line-clamp-1 cursor-default text-[11px] mt-0.5">{pickup.address || ''}</div>
                                                            {pickup.address && addrHover.id === row.id && addrHover.type === 'pickup' && (
                                                                <div className={`absolute left-0 z-[999] flex flex-col w-52 pointer-events-none
                                                                    ${addrHover.above ? 'bottom-full mb-1' : 'top-full mt-1'}`}>
                                                                    {!addrHover.above && <div className="ml-3 w-2.5 h-2.5 bg-emerald-500 rotate-45 -mb-1.5 relative z-10" />}
                                                                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-600 overflow-hidden">
                                                                        <div className="bg-gradient-to-r from-emerald-500 to-teal-500 px-3 py-2 flex items-center gap-2">
                                                                            <span className="text-white text-sm">📦</span>
                                                                            <div>
                                                                                <div className="text-white font-semibold text-[11px]">Origin</div>
                                                                                <div className="text-emerald-100 text-[10px]">{pickup.city || ''}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="divide-y divide-gray-100 dark:divide-gray-700">
                                                                            {pickup.consignee_name && (
                                                                                <div className="flex items-center gap-2 px-3 py-1.5">
                                                                                    <span className="text-[11px]">👤</span>
                                                                                    <div>
                                                                                        <div className="text-[9px] text-gray-400 uppercase tracking-wide">Consignee</div>
                                                                                        <div className="text-[10px] font-semibold text-gray-800 dark:text-white">{pickup.consignee_name}</div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            <div className="flex items-start gap-2 px-3 py-1.5">
                                                                                <span className="text-[11px] mt-0.5">📍</span>
                                                                                <div>
                                                                                    <div className="text-[9px] text-gray-400 uppercase tracking-wide">Address</div>
                                                                                    <div className="text-[10px] font-semibold text-gray-800 dark:text-white leading-relaxed">{pickup.address}</div>
                                                                                    <div className="text-[10px] text-gray-500">{pickup.city}{pickup.state ? ', ' + pickup.state : ''}{pickup.zip ? ' - ' + pickup.zip : ''}</div>
                                                                                </div>
                                                                            </div>
                                                                            {pickup.phone && (
                                                                                <div className="flex items-center gap-2 px-3 py-1.5">
                                                                                    <span className="text-[11px]">📞</span>
                                                                                    <div>
                                                                                        <div className="text-[9px] text-gray-400 uppercase tracking-wide">Phone</div>
                                                                                        <div className="text-[10px] font-semibold text-gray-800 dark:text-white">{pickup.phone}</div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {addrHover.above && <div className="ml-3 w-2.5 h-2.5 bg-white dark:bg-gray-800 border-r border-b border-gray-200 dark:border-gray-600 rotate-45 -mt-1.5 relative z-10" />}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>

                                                    <td className="py-4 px-3 text-xs">
                                                        <div className="font-medium text-gray-700 dark:text-gray-200">{dropoff.city || '—'}</div>
                                                        <div className="relative"
                                                            onMouseEnter={(e) => handleAddrEnter(e, row.id, 'dropoff')}
                                                            onMouseLeave={handleAddrLeave}>
                                                            <div className="text-gray-400 line-clamp-1 cursor-default text-[11px] mt-0.5">{dropoff.address || ''}</div>
                                                            {dropoff.address && addrHover.id === row.id && addrHover.type === 'dropoff' && (
                                                                <div className={`absolute left-0 z-[999] flex flex-col w-52 pointer-events-none
                                                                    ${addrHover.above ? 'bottom-full mb-1' : 'top-full mt-1'}`}>
                                                                    {!addrHover.above && <div className="ml-3 w-2.5 h-2.5 bg-rose-500 rotate-45 -mb-1.5 relative z-10" />}
                                                                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-600 overflow-hidden">
                                                                        <div className="bg-gradient-to-r from-rose-500 to-pink-500 px-3 py-2 flex items-center gap-2">
                                                                            <span className="text-white text-sm">🎯</span>
                                                                            <div>
                                                                                <div className="text-white font-semibold text-[11px]">Destination</div>
                                                                                <div className="text-rose-100 text-[10px]">{dropoff.city || ''}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="divide-y divide-gray-100 dark:divide-gray-700">
                                                                            {dropoff.consignee_name && (
                                                                                <div className="flex items-center gap-2 px-3 py-1.5">
                                                                                    <span className="text-[11px]">👤</span>
                                                                                    <div>
                                                                                        <div className="text-[9px] text-gray-400 uppercase tracking-wide">Consignee</div>
                                                                                        <div className="text-[10px] font-semibold text-gray-800 dark:text-white">{dropoff.consignee_name}</div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            <div className="flex items-start gap-2 px-3 py-1.5">
                                                                                <span className="text-[11px] mt-0.5">📍</span>
                                                                                <div>
                                                                                    <div className="text-[9px] text-gray-400 uppercase tracking-wide">Address</div>
                                                                                    <div className="text-[10px] font-semibold text-gray-800 dark:text-white leading-relaxed">{dropoff.address}</div>
                                                                                    <div className="text-[10px] text-gray-500">{dropoff.city}{dropoff.state ? ', ' + dropoff.state : ''}{dropoff.zip ? ' - ' + dropoff.zip : ''}</div>
                                                                                </div>
                                                                            </div>
                                                                            {dropoff.phone && (
                                                                                <div className="flex items-center gap-2 px-3 py-1.5">
                                                                                    <span className="text-[11px]">📞</span>
                                                                                    <div>
                                                                                        <div className="text-[9px] text-gray-400 uppercase tracking-wide">Phone</div>
                                                                                        <div className="text-[10px] font-semibold text-gray-800 dark:text-white">{dropoff.phone}</div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {addrHover.above && <div className="ml-3 w-2.5 h-2.5 bg-white dark:bg-gray-800 border-r border-b border-gray-200 dark:border-gray-600 rotate-45 -mt-1.5 relative z-10" />}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>

                                                    <td className="py-4 px-1 text-sm">
                                                        {row.shipment_details ? JSON.parse(row.shipment_details || '[]')[0]?.description || '—' : '—'}
                                                    </td>

                                                    <td className="py-4 px-1 text-center font-medium">{row.total_boxes || 0}</td>
                                                    {/* <td className="py-4 px-3 text-center font-medium">
                                                        <div className="relative inline-block"
                                                            onMouseEnter={(e) => handleWeightEnter(e, row.id)}
                                                            onMouseLeave={handleWeightLeave}>
                                                            <span className="cursor-default text-gray-700 dark:text-gray-200">{row.total_weight || 0} kg</span>
                                                            {weightHover.id === row.id && (() => {
                                                                let dims = [];
                                                                try { dims = JSON.parse(row.dimensions || '[]'); } catch (e) { }
                                                                const hasDims = dims.length > 0 || row.total_length || row.total_width || row.total_height;
                                                                if (!hasDims) return null;
                                                                return (
                                                                    <div className={`absolute left-1/2 -translate-x-1/2 z-[999] flex flex-col items-center w-52 pointer-events-none
                                                                        ${weightHover.above ? 'bottom-full mb-1' : 'top-full mt-1'}`}>
                                                                        {!weightHover.above && <div className="w-2.5 h-2.5 bg-violet-500 rotate-45 -mb-1.5 relative z-10" />}
                                                                        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-600 overflow-hidden w-full">
                                                                            <div className="bg-gradient-to-r from-violet-500 to-indigo-500 px-3 py-2 flex items-center gap-2">
                                                                                <span className="text-white text-sm">📐</span>
                                                                                <div>
                                                                                    <div className="text-white font-semibold text-[11px]">Dimensions</div>
                                                                                    <div className="text-violet-100 text-[10px]">{row.total_boxes || 0} box{(row.total_boxes || 0) > 1 ? 'es' : ''} · {row.total_weight || 0} kg total</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="divide-y divide-gray-100 dark:divide-gray-700 max-h-48 overflow-y-auto">
                                                                                {dims.length > 0 ? dims.map((d, i) => (
                                                                                    <div key={i} className="flex items-center gap-2 px-3 py-1.5">
                                                                                        <span className="text-[11px]">📦</span>
                                                                                        <div>
                                                                                            <div className="text-[9px] text-gray-400 uppercase tracking-wide">Box set {i + 1} {d.box_count > 1 ? `(×${d.box_count})` : ''}</div>
                                                                                            <div className="text-[10px] font-semibold text-gray-800 dark:text-white">{d.length || 0} × {d.width || 0} × {d.height || 0} cm</div>
                                                                                        </div>
                                                                                    </div>
                                                                                )) : (
                                                                                    <div className="flex items-center gap-2 px-3 py-1.5">
                                                                                        <span className="text-[11px]">↔️</span>
                                                                                        <div>
                                                                                            <div className="text-[9px] text-gray-400 uppercase tracking-wide">L × W × H</div>
                                                                                            <div className="text-[10px] font-semibold text-gray-800 dark:text-white">{row.total_length || 0} × {row.total_width || 0} × {row.total_height || 0} cm</div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        {weightHover.above && <div className="w-2.5 h-2.5 bg-white dark:bg-gray-800 border-r border-b border-gray-200 dark:border-gray-600 rotate-45 -mt-1.5 relative z-10" />}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td> */}
                                                    {/* Weight Column */}
                                                    {/* Weight Column */}
                                                    <td className="py-4 px-1 text-center text-xs">
                                                        <div
                                                            className="relative inline-block"
                                                            onMouseEnter={(e) => handleWeightEnter(e, row.id)}
                                                            onMouseLeave={handleWeightLeave}
                                                        >
                                                            {/* Weight (smaller text) */}
                                                            <div className="text-xs font-semibold text-gray-700 dark:text-gray-200">
                                                                {row.total_weight || 0} kg
                                                            </div>

                                                            {/* Dimension Count */}
                                                            <div className="text-[9px] text-gray-400 mt-0.5">
                                                                {(() => {
                                                                    let dims = [];
                                                                    try {
                                                                        dims = JSON.parse(row.dimensions || "[]");
                                                                    } catch (e) { }

                                                                    const totalDims =
                                                                        dims.length > 0
                                                                            ? dims.reduce(
                                                                                (sum, d) =>
                                                                                    sum + (parseInt(d.box_count) || 1),
                                                                                0
                                                                            )
                                                                            : row.total_boxes || 0;

                                                                    return `${totalDims} Dim`;
                                                                })()}
                                                            </div>

                                                            {/* Hover Card */}
                                                            {weightHover.id === row.id &&
                                                                (() => {
                                                                    let dims = [];
                                                                    try {
                                                                        dims = JSON.parse(row.dimensions || "[]");
                                                                    } catch (e) { }

                                                                    const hasDims =
                                                                        dims.length > 0 ||
                                                                        row.total_length ||
                                                                        row.total_width ||
                                                                        row.total_height;

                                                                    if (!hasDims) return null;

                                                                    return (
                                                                        <div
                                                                            className={`absolute left-1/2 -translate-x-1/2 z-[999] flex flex-col items-center w-56 pointer-events-none
                            ${weightHover.above
                                                                                    ? "bottom-full mb-1"
                                                                                    : "top-full mt-1"
                                                                                }`}
                                                                        >
                                                                            {/* Arrow */}
                                                                            {!weightHover.above && (
                                                                                <div className="w-2.5 h-2.5 bg-violet-500 rotate-45 -mb-1.5 relative z-10" />
                                                                            )}

                                                                            {/* Card */}
                                                                            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-600 overflow-hidden w-full">
                                                                                {/* Header */}
                                                                                <div className="bg-gradient-to-r from-violet-500 to-indigo-500 px-3 py-2 flex items-center gap-2">
                                                                                    <span className="text-white text-xs">📐</span>
                                                                                    <div>
                                                                                        <div className="text-white font-semibold text-[10px]">
                                                                                            Dimensions
                                                                                        </div>
                                                                                        <div className="text-violet-100 text-[9px]">
                                                                                            {row.total_boxes || 0} box
                                                                                            {(row.total_boxes || 0) > 1
                                                                                                ? "es"
                                                                                                : ""}{" "}
                                                                                            · {row.total_weight || 0} kg
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Dimension List */}
                                                                                <div
                                                                                    className={`divide-y divide-gray-100 dark:divide-gray-700
                                    ${dims.length > 5
                                                                                            ? "max-h-48 overflow-y-auto"
                                                                                            : ""
                                                                                        }`}
                                                                                >
                                                                                    {dims.length > 0 ? (
                                                                                        dims.map((d, i) => (
                                                                                            <div
                                                                                                key={i}
                                                                                                className="flex items-center gap-2 px-3 py-1.5"
                                                                                            >
                                                                                                <span className="text-[10px]">
                                                                                                    📦
                                                                                                </span>
                                                                                                <div>
                                                                                                    <div className="text-[8px] text-gray-400 uppercase tracking-wide">
                                                                                                        Box {i + 1}
                                                                                                        {d.box_count > 1
                                                                                                            ? ` (×${d.box_count})`
                                                                                                            : ""}
                                                                                                    </div>
                                                                                                    <div className="text-[9px] font-semibold text-gray-800 dark:text-white">
                                                                                                        {d.length || 0} ×{" "}
                                                                                                        {d.width || 0} ×{" "}
                                                                                                        {d.height || 0} cm
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        ))
                                                                                    ) : (
                                                                                        <div className="flex items-center gap-2 px-3 py-1.5">
                                                                                            <span className="text-[10px]">↔️</span>
                                                                                            <div>
                                                                                                <div className="text-[8px] text-gray-400 uppercase tracking-wide">
                                                                                                    L × W × H
                                                                                                </div>
                                                                                                <div className="text-[9px] font-semibold text-gray-800 dark:text-white">
                                                                                                    {row.total_length || 0} ×{" "}
                                                                                                    {row.total_width || 0} ×{" "}
                                                                                                    {row.total_height || 0} cm
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            {/* Bottom Arrow */}
                                                                            {weightHover.above && (
                                                                                <div className="w-2.5 h-2.5 bg-white dark:bg-gray-800 border-r border-b border-gray-200 dark:border-gray-600 rotate-45 -mt-1.5 relative z-10" />
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })()}
                                                        </div>
                                                    </td>
                                                    <td className="py-4 px-1 text-right font-semibold">₹{parseFloat(row.debit_amount || 0).toFixed(2)}</td>

                                                    {/* <td className="py-4 px-3 text-center">
                                                        <span className={`px-3 py-1 text-xs font-medium rounded-full ${getStatusStyle(row.status)}`}>
                                                            {row.status}
                                                        </span>
                                                    </td> */}
                                                    {/* Status Column with Hover Tooltip */}
                                                    <td className="py-4 px-1 text-center">
                                                        {(() => {
                                                            const fullStatus = row.status || "—";

                                                            // Short code mapping
                                                            const statusShortMap = {
                                                                LEFT_ORIGIN: "LO",
                                                                Manifested: "MF",
                                                                Pending: "PD",
                                                                Failed: "FL",
                                                                Cancelled: "CN",
                                                                Delivered: "DL",
                                                                In_Transit: "IT",
                                                                Out_For_Delivery: "OFD",
                                                                RTO: "RTO",
                                                            };

                                                            // Convert full status to short code
                                                            const shortStatus =
                                                                statusShortMap[fullStatus] ||
                                                                fullStatus
                                                                    .replace(/_/g, " ")
                                                                    .split(" ")
                                                                    .map(word => word[0])
                                                                    .join("")
                                                                    .slice(0, 3)
                                                                    .toUpperCase();

                                                            // Human readable full status
                                                            const readableStatus = fullStatus
                                                                .replace(/_/g, " ")
                                                                .replace(/\b\w/g, char => char.toUpperCase());

                                                            return (
                                                                <div className="relative inline-block group">
                                                                    {/* Short Status Badge */}
                                                                    <span
                                                                        className={`px-3 py-1 text-xs font-semibold rounded-full cursor-default ${getStatusStyle(fullStatus)}`}
                                                                    >
                                                                        {shortStatus}
                                                                    </span>

                                                                    {/* Hover Tooltip */}
                                                                    <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 z-[999] hidden group-hover:block pointer-events-none">
                                                                        {/* Arrow */}
                                                                        <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 mx-auto -mb-1"></div>

                                                                        {/* Tooltip Box */}
                                                                        <div className="bg-gray-900 text-white text-[11px] font-medium px-3 py-1.5 rounded-lg shadow-xl whitespace-nowrap">
                                                                            {readableStatus}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })()}
                                                    </td>

                                                    <td className="py-4 px-1 text-center text-xs text-gray-500">
                                                        {new Date(row.created_at).toLocaleDateString('en-IN')}
                                                    </td>

                                                    <td className="py-4 px-1 text-center">
                                                        <div className="flex justify-center items-center gap-4">

                                                            {/* View — always visible for all statuses */}
                                                            <FaEye
                                                                className="cursor-pointer text-indigo-600 hover:scale-110 transition-transform"
                                                                size={17}
                                                                onClick={() => handleViewClick(row)}
                                                            />

                                                            {/* Failed — only Reason button */}
                                                            {/* Failed — only Reason icon (no button) */}
                                                            {isFailed && (
                                                                     <div className="relative">
                                                                <FaExclamationCircle
                                                                    size={16}
                                                                    title="View failure reason"
                                                                    onClick={() => handleShowFailedReason(row)}
                                                                    className="cursor-pointer text-red-500 hover:text-red-600 hover:scale-110 transition-transform"
                                                                />
                                                                </div>
                                                            )}

                                                            {/* Pending only — Cancel button */}
                                                            {isPending && (
                                                                <RxCross2
                                                                    className="cursor-pointer text-red-500 hover:scale-110 transition-transform"
                                                                    size={18}
                                                                    title="Cancel Order"
                                                                    onClick={() => handleCancelOrder(row.order_id)}
                                                                />
                                                            )}

                                                            {/* Pending only — Ship Now button */}
                                                            {isPending && (
                                                                <button
                                                                    onClick={() => hanldeShipNow(row)}
                                                                    className="hover:scale-110 transition-transform text-xl"
                                                                    title="Ship Now"
                                                                >
                                                                    🚚
                                                                </button>
                                                            )}

                                                            {/* Print dropdown — only when NOT pending and NOT failed */}
                                                            {!isPending && !isFailed && (
                                                                <div className="relative">
                                                                    <FcPrint
                                                                        className="cursor-pointer hover:scale-110 transition-transform"
                                                                        size={20}
                                                                        title="Print / Download"
                                                                        onClick={() => setShowSizeDropdown(showSizeDropdown === row.order_id ? null : row.order_id)}
                                                                    />
                                                                    {showSizeDropdown === row.order_id && (
                                                                        <div className="absolute right-0 mt-2 bg-white dark:bg-gray-800 shadow-xl rounded-xl p-1 z-50 w-36 border border-gray-200 dark:border-gray-700">
                                                                            {/* Label size options */}
                                                                            {labelSizes.map(s => (
                                                                                <div
                                                                                    key={s.value}
                                                                                    onClick={() => handlePrintLabel(row.order_id, s.value)}
                                                                                    className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-sm rounded-lg flex items-center gap-2"
                                                                                >
                                                                                    <FcPrint size={14} />
                                                                                    Label {s.label}
                                                                                </div>
                                                                            ))}
                                                                            {/* CHANGE 3: Waybill download — shown only if AWB exists */}
                                                                            {hasWaybill && (
                                                                                <div
                                                                                    onClick={() => handleDownloadWaybill(row.order_id)}
                                                                                    className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-sm rounded-lg flex items-center gap-2 border-t border-gray-100 dark:border-gray-700 mt-1"
                                                                                >
                                                                                    <FaDownload size={12} className="text-purple-600" />
                                                                                    Waybill
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}

                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* ===== MOBILE CARD VIEW ===== */}
                    {isMobileCardView && (
                        <div className="space-y-3">
                            {paginatedData.length === 0 && (
                                <div className="text-center py-16 text-gray-400">No shipments found</div>
                            )}
                            {paginatedData.map((row, index) => {
                                const pickup = row.pickup_location ? JSON.parse(row.pickup_location || '{}') : {};
                                const dropoff = row.dropoff_location ? JSON.parse(row.dropoff_location || '{}') : {};
                                const statusLower = row.status?.toLowerCase() || "";
                                const isManifestPending = statusLower === "manifest pending";
                                const isPending = statusLower.includes("pending") && !isManifestPending;
                                const isFailed = statusLower.includes("failed");
                                const hasWaybill = !!(row.waybill || row.lrn);
                                const isTrackDisabled = isPending || isManifestPending || !hasWaybill;
                                let billing = {};
                                try { billing = JSON.parse(row.billing_address || '{}'); } catch (e) { }

                                return (
                                    <div key={row.id}
                                        className={`bg-white dark:bg-gray-900 rounded-2xl shadow-sm border overflow-hidden
                                            ${isFailed ? 'border-red-200 dark:border-red-800' : 'border-gray-200 dark:border-gray-700'}`}
                                        style={{ animationDelay: `${index * 40}ms` }}
                                    >
                                        {/* Card Top Bar */}
                                        <div className={`px-4 py-2.5 flex items-center justify-between
                                            ${isFailed ? 'bg-red-50 dark:bg-red-950/30' : 'bg-slate-50 dark:bg-gray-800'}`}>
                                            <div className="flex items-center gap-2">
                                                <span
                                                    onClick={() => !isTrackDisabled && (setorderId(row.order_id), navigateForTrack("/b2b/shipment/track"))}
                                                    className={`font-bold text-sm ${isTrackDisabled ? 'text-gray-400 cursor-not-allowed' : 'text-indigo-600 cursor-pointer'}`}
                                                >
                                                    #{row.order_id}
                                                </span>
                                                <FaCopy className="text-gray-400 cursor-pointer" size={12} onClick={() => copyToClipboard(row.order_id, "Order ID")} />
                                            </div>
                                            <span className={`px-2.5 py-1 text-[10px] font-semibold rounded-full ${getStatusStyle(row.status)}`}>
                                                {row.status}
                                            </span>
                                        </div>

                                        <div className="px-4 py-3 space-y-3">
                                            {/* AWB */}
                                            {hasWaybill && (
                                                <div className="text-[11px] text-indigo-500 font-medium">AWB: {row.waybill || row.lrn}</div>
                                            )}

                                            {/* Admin user info */}
                                            {isAdmin && (
                                                <div className="flex items-center gap-2 bg-indigo-50 dark:bg-indigo-900/20 rounded-xl px-3 py-2">
                                                    <div className="w-8 h-8 rounded-full overflow-hidden bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center flex-shrink-0">
                                                        {(row.profile_image || row.user_profile || row.avatar)
                                                            ? <img src={row.profile_image || row.user_profile || row.avatar} alt="" className="w-full h-full object-cover" />
                                                            : <span className="text-white font-bold text-[12px]">{(billing.name || row.user_name || 'U').charAt(0).toUpperCase()}</span>
                                                        }
                                                    </div>
                                                    <div>
                                                        <div className="text-xs font-semibold text-gray-700 dark:text-gray-200 capitalize">{billing.name || row.user_name || '—'}</div>
                                                        <div className="text-[10px] text-indigo-500">#{row.user_id} {billing.phone ? '· ' + billing.phone : ''}</div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Origin → Destination */}
                                            <div className="flex items-start gap-2">
                                                <div className="flex flex-col items-center mt-1 flex-shrink-0">
                                                    <div className="w-2 h-2 rounded-full bg-emerald-500" />
                                                    <div className="w-0.5 h-6 bg-gray-300 dark:bg-gray-600 my-0.5" />
                                                    <div className="w-2 h-2 rounded-full bg-red-500" />
                                                </div>
                                                <div className="flex-1 min-w-0 space-y-2">
                                                    <div>
                                                        <div className="text-xs font-semibold text-gray-700 dark:text-gray-200">{pickup.city || '—'}</div>
                                                        <div className="text-[10px] text-gray-400 truncate">{pickup.address || ''}</div>
                                                    </div>
                                                    <div>
                                                        <div className="text-xs font-semibold text-gray-700 dark:text-gray-200">{dropoff.city || '—'}</div>
                                                        <div className="text-[10px] text-gray-400 truncate">{dropoff.address || ''}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Stats Row */}
                                            <div className="grid grid-cols-3 gap-2 text-center">
                                                <div className="bg-gray-50 dark:bg-gray-800 rounded-xl py-2">
                                                    <div className="text-xs font-bold text-gray-800 dark:text-white">{row.total_boxes || 0}</div>
                                                    <div className="text-[10px] text-gray-400">Boxes</div>
                                                </div>
                                                <div className="bg-gray-50 dark:bg-gray-800 rounded-xl py-2">
                                                    <div className="text-xs font-bold text-gray-800 dark:text-white">{row.total_weight || 0} kg</div>
                                                    <div className="text-[10px] text-gray-400">{row.total_length && `${row.total_length}×${row.total_width}×${row.total_height}`}</div>
                                                </div>
                                                <div className="bg-gray-50 dark:bg-gray-800 rounded-xl py-2">
                                                    <div className="text-xs font-bold text-gray-800 dark:text-white">₹{parseFloat(row.debit_amount || 0).toFixed(0)}</div>
                                                    <div className="text-[10px] text-gray-400">Amount</div>
                                                </div>
                                            </div>

                                            {/* Date */}
                                            <div className="text-[10px] text-gray-400">{new Date(row.created_at).toLocaleDateString('en-IN')}</div>

                                            {/* Action Buttons */}
                                            <div className="flex items-center gap-2 pt-1 border-t border-gray-100 dark:border-gray-700 flex-wrap">
                                                {/* View */}
                                                <button onClick={() => handleViewClick(row)}
                                                    className="flex items-center gap-1.5 px-3 py-1.5 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 rounded-lg text-xs font-medium">
                                                    <FaEye size={12} /> View
                                                </button>

                                                {/* Failed reason */}
                                                {isFailed && (
                                                    <button onClick={() => handleShowFailedReason(row)}
                                                        className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 dark:bg-red-900/30 text-red-600 rounded-lg text-xs font-medium">
                                                        <FaExclamationCircle size={12} />
                                                    </button>
                                                )}

                                                {/* Pending: cancel + ship */}
                                                {isPending && (
                                                    <>
                                                        <button onClick={() => handleCancelOrder(row.order_id)}
                                                            className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 dark:bg-red-900/30 text-red-500 rounded-lg text-xs font-medium">
                                                            <RxCross2 size={12} /> Cancel
                                                        </button>
                                                        <button onClick={() => hanldeShipNow(row)}
                                                            className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 rounded-lg text-xs font-medium">
                                                            🚚 Ship Now
                                                        </button>
                                                    </>
                                                )}

                                                {/* Print/Waybill: not pending, not failed */}
                                                {!isPending && !isFailed && (
                                                    <div className="relative">
                                                        <button
                                                            onClick={() => setShowSizeDropdown(showSizeDropdown === row.order_id ? null : row.order_id)}
                                                            className="flex items-center gap-1.5 px-3 py-1.5 bg-purple-50 dark:bg-purple-900/30 text-purple-600 rounded-lg text-xs font-medium">
                                                            <FcPrint size={13} /> Print
                                                        </button>
                                                        {showSizeDropdown === row.order_id && (
                                                            <div className="absolute left-0 bottom-full mb-2 bg-white dark:bg-gray-800 shadow-xl rounded-xl p-1 z-50 w-36 border border-gray-200 dark:border-gray-700">
                                                                {labelSizes.map(s => (
                                                                    <div key={s.value} onClick={() => handlePrintLabel(row.order_id, s.value)}
                                                                        className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-sm rounded-lg flex items-center gap-2">
                                                                        <FcPrint size={13} /> Label {s.label}
                                                                    </div>
                                                                ))}
                                                                {hasWaybill && (
                                                                    <div
                                                                        onClick={() => handleDownloadWaybill(row.order_id)}
                                                                        className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-sm rounded-lg flex items-center gap-2 border-t border-gray-100 dark:border-gray-700 mt-1 text-purple-600 font-medium"
                                                                    >
                                                                        <FaDownload size={13} />
                                                                        Waybill / E-Waybill
                                                                    </div>
                                                                )}

                                                                {!hasWaybill && (
                                                                    <div className="px-3 py-2 text-xs text-gray-400 italic">
                                                                        Waybill not generated yet
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {totalPages > 1 && (
                        <div className="flex justify-center mt-8">
                            <Pagination count={totalPages} page={currentPage} onChange={(e, v) => setCurrentPage(v)} color="primary" />
                        </div>
                    )}
                </div>
            </div>

            {/* CHANGE 2: Failed Reason Modal */}
            {failedReasonPopup.open && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
                    <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl p-6 w-full max-w-md mx-4 border border-red-200 dark:border-red-800">
                        <div className="flex items-center gap-3 mb-4">
                            <div className="w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/40 flex items-center justify-center flex-shrink-0">
                                <FaExclamationCircle className="text-red-600" size={20} />
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800 dark:text-white text-lg">Failure Reason</h3>
                                <p className="text-xs text-gray-500">Order #{failedReasonPopup.orderId}</p>
                            </div>
                        </div>
                        <div className="bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-800 rounded-xl p-4 mb-5">
                            <p className="text-sm text-red-700 dark:text-red-300 leading-relaxed">
                                {failedReasonPopup.reason}
                            </p>
                        </div>
                        <button
                            onClick={() => setFailedReasonPopup({ open: false, reason: '', orderId: '' })}
                            className="w-full py-2.5 bg-gray-800 dark:bg-gray-700 text-white rounded-xl text-sm font-medium hover:bg-gray-700 dark:hover:bg-gray-600 transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}

            <B2BViewRateForword isopen={false} onClose={() => { }} data={selectedShipment} />
            <B2BViewAllShipment isopen={isPopupOpen} onClose={() => setIsPopupOpen(false)} shipment={selectedShipment} />
        </div>
    );
};

export default B2bAllShipmentList;